import { useContext, useMemo } from "react";
import { SubscriptionsContext } from "./dashboard/store/SubscriptionsContext";

const CsaTiersDisplay = () => {
  const { subscriptions, tiers } = useContext(SubscriptionsContext);

  const subscriptionOptions = useMemo(() => {
    return subscriptions.map((sub) => {
      const subTiers = tiers.filter((tier) => tier.subscriptionId === sub.id);
      const tierList = subTiers.map((tier) => {
        return (
          <div key={tier.id} className="info-card csa-price-box">
            <h4>{tier.name}</h4>
            <p>
              <span className="bold">{tier.price}:-</span>
            </p>
            <p className="gray-text">
              Returning member price: {tier.oldCsaMemberPrice} :-
            </p>
          </div>
        );
      });
      return (
        <div key={sub.id} className="info-card csa-subscription-box">
          <h3>{sub.name}</h3>
          <div className="csa-page-list-of-tiers">{tierList}</div>
        </div>
      );
    });
  }, [subscriptions, tiers]);

  return <>{subscriptionOptions}</>;
};

export default CsaTiersDisplay;
